const type = {
    state: {
        // empty
    },
    mutations: {
        // empty
    },
    actions: {
        // empty
    },
    getters: {
        /* eslint-disable no-unused-vars */
        allStats(state) {
            return [
                'Kärnten',
                'Steiermark',
                'Oberösterreich'
            ]
        },
        /* eslint-disable no-unused-vars */
        allMapMarkers(state) {
            return [
                {
                    /* http://trefle.io/api/plants/101820?token=RzkvdU9hb1gwQUVJMjZTNVhXT2kydz09 */
                    /* https://en.wikipedia.org/wiki/Acer_negundo */

                    scientific_name: "Acer negundo", /* Wissenschaftlicher Name */
                    scientific_name_de: "Eschen-Ahorn",
                    genus: "Acer", /* Gattung */
                    genus_de: "Ahorne",
                    family: "Sapindaceae", /* Familie */
                    family_de: "Seifenbaumgewächse",
                    characteristics: null,
                    characteristics_de: "Der Eschen-Ahorn (lat. acer negundo) ist ein laubabwerfender Baum, der Wuchshöhen bis zu 15 Metern und Stammdurchmesser von etwa 0,5 Metern erreichen kann. Er gehört zur Familie der Seifenbaumgewächse und kommt in Mitteleuropa vor. Er einer der am meisten gepflanzten fremdländischen Gehölze.",
                    distribution: null,
                    distribution_de: "Mitteleuropa",
                    position: {
                        lat: 46.62472,
                        lng: 14.30528
                    },
                    images: [
                        "https://upload.wikimedia.org/wikipedia/commons/8/86/Acer_negundo_2.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/f/f8/Acer_negundo_bark-Clapiers~2010_04_05.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/1/18/Acnegundo.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/e/e3/Acer_negundo_tree.jpg"
                    ]
                },
                {
                    position: {
                        lat: 46.61123,
                        lng: 14.30123
                    },
                    scientific_name: "Fallopia japonica",
                    scientific_name_de: "Japan-Flügel Knöterich",
                    characteristics: null,
                    characteristics_de: "Der Japan-Flügel Knöterich (lat. fallopia japonica) ist eine Pflanzengattung innerhalb der Familie der Knöterichgewächse. Die 7 bis 18 Arten sind in den gemäßigten bis subtropischen Zonen der Nordhalbkugel weit verbreitet.",
                    images: [
                        "https://upload.wikimedia.org/wikipedia/commons/5/54/Variegated_Japanese_Knotweed_Foliage.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/a/a7/Fallopia_japonica_MdE_2.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/4/40/Fallopia_overgrows_train.jpg",
                        "https://upload.wikimedia.org/wikipedia/commons/2/26/WEEDS054.jpg"
                    ]
                },
            ]
        }
    }
}

export default type
